import { c as _c } from "react/compiler-runtime";
import { Icon } from '@/app/components/icons';
import { IconCall } from '@/app/components/icons/communication/icon-call';
import { IconLine } from '@/app/components/icons/social-media/icon-line';
import { Link } from '@/app/components/navigation/link';
import { groupDealerTels } from '@/app/components/sections/dealer/utils/format';
import { toLineLink } from '@/app/components/sections/dealer/utils/mapping-dealer';
import type { DealerDetailProps } from '@/app/components/sections/special-offer/detail/search-dealer-contact/types';
import { SPECIAL_OFFER_DATA_TEST, SPECIAL_OFFER_EVENT_NAME } from '@/app/components/sections/special-offer/tracking';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import type { DealerTel } from '@/services/contentstack/models/dealer';
type GroupedTel = ReturnType<typeof groupDealerTels>[number];
const AppointmentContactLink = t0 => {
  const $ = _c(16);
  const {
    group,
    index
  } = t0;
  let t1;
  if ($[0] !== group.exts) {
    t1 = group.exts.length > 0 ? ` ต่อ ${group.exts.join(", ")}` : "";
    $[0] = group.exts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const extLabel = t1;
  const t2 = `tel:${group.stripDash}`;
  const t3 = `contact-phone-${index}`;
  let t4;
  if ($[2] !== t3) {
    t4 = createDataAttributes({
      test: t3
    });
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `tel:${group.stripDash}`;
  let t6;
  if ($[4] !== extLabel || $[5] !== group.displayBase || $[6] !== t5) {
    t6 = createDataGA({
      eventName: SPECIAL_OFFER_EVENT_NAME,
      group: SPECIAL_OFFER_DATA_TEST.DEALER_CONTACT,
      click: true,
      url: t5,
      text: `${group.displayBase}${extLabel}`.trim()
    });
    $[4] = extLabel;
    $[5] = group.displayBase;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== extLabel) {
    t7 = !!extLabel && <span className="pl-1">{extLabel}</span>;
    $[8] = extLabel;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== group.displayBase || $[11] !== t2 || $[12] !== t4 || $[13] !== t6 || $[14] !== t7) {
    t8 = <Link target="_blank" href={t2} className="where-span:text-inline-wrap text-gray-700 underline" {...t4} {...t6}>{group.displayBase}{t7}</Link>;
    $[10] = group.displayBase;
    $[11] = t2;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
const AppointmentContacts = t0 => {
  const $ = _c(5);
  const {
    contacts
  } = t0;
  let t1;
  let t2;
  if ($[0] !== contacts) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const groups = groupDealerTels(contacts);
      if (groups.length === 0) {
        t2 = "-";
        break bb0;
      }
      if (groups.length === 1) {
        t2 = <AppointmentContactLink group={groups[0]} index={0} />;
        break bb0;
      }
      t1 = groups.map(_temp);
    }
    $[0] = contacts;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <ul>{t1}</ul>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const DealerDetail = t0 => {
  const $ = _c(68);
  const {
    dealer,
    lineId
  } = t0;
  let t1;
  if ($[0] !== dealer.afterSaleAppointmentContact) {
    t1 = dealer.afterSaleAppointmentContact?.filter(Boolean) ?? [];
    $[0] = dealer.afterSaleAppointmentContact;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const appointmentContacts = t1 as DealerTel[];
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== appointmentContacts || $[3] !== dealer.afterSaleOpenTimeHourMonFri || $[4] !== dealer.afterSaleOpenTimeHourSat || $[5] !== dealer.afterSaleOpenTimeHourSun || $[6] !== dealer.afterSaleOpenTimeRemark || $[7] !== lineId) {
    const lineLink = lineId ? toLineLink(lineId) : undefined;
    t10 = "text-body-2 mt-4 grid grid-cols-1 gap-x-12 gap-y-4 xl:mt-6 xl:grid-cols-2";
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = createDataAttributes({
        test: "dealer-detail"
      });
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    let t13;
    let t14;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = createDataAttributes({
        test: "dealer-detail-open-time"
      });
      t14 = <p className="font-noto-bold">วันและเวลาทำการ</p>;
      $[20] = t13;
      $[21] = t14;
    } else {
      t13 = $[20];
      t14 = $[21];
    }
    let t15;
    let t16;
    let t17;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = createDataAttributes({
        test: "dealer-detail-open-time-list"
      });
      t16 = <dt {...createDataAttributes({
        test: "title-0"
      })}>จันทร์ - ศุกร์</dt>;
      t17 = createDataAttributes({
        test: "value-0"
      });
      $[22] = t15;
      $[23] = t16;
      $[24] = t17;
    } else {
      t15 = $[22];
      t16 = $[23];
      t17 = $[24];
    }
    const t18 = dealer.afterSaleOpenTimeHourMonFri || "-";
    let t19;
    if ($[25] !== t18) {
      t19 = <dd {...t17}>{t18}</dd>;
      $[25] = t18;
      $[26] = t19;
    } else {
      t19 = $[26];
    }
    let t20;
    let t21;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <dt {...createDataAttributes({
        test: "title-1"
      })}>เสาร์</dt>;
      t21 = createDataAttributes({
        test: "value-1"
      });
      $[27] = t20;
      $[28] = t21;
    } else {
      t20 = $[27];
      t21 = $[28];
    }
    const t22 = dealer.afterSaleOpenTimeHourSat || "-";
    let t23;
    if ($[29] !== t22) {
      t23 = <dd {...t21}>{t22}</dd>;
      $[29] = t22;
      $[30] = t23;
    } else {
      t23 = $[30];
    }
    let t24;
    let t25;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <dt {...createDataAttributes({
        test: "title-2"
      })}>อาทิตย์</dt>;
      t25 = createDataAttributes({
        test: "value-2"
      });
      $[31] = t24;
      $[32] = t25;
    } else {
      t24 = $[31];
      t25 = $[32];
    }
    const t26 = dealer.afterSaleOpenTimeHourSun || "-";
    let t27;
    if ($[33] !== t26) {
      t27 = <dd {...t25}>{t26}</dd>;
      $[33] = t26;
      $[34] = t27;
    } else {
      t27 = $[34];
    }
    let t28;
    if ($[35] !== t19 || $[36] !== t23 || $[37] !== t27) {
      t28 = <dl className="grid grid-cols-2 gap-x-4 gap-y-2 text-gray-700" {...t15}>{t16}{t19}{t20}{t23}{t24}{t27}</dl>;
      $[35] = t19;
      $[36] = t23;
      $[37] = t27;
      $[38] = t28;
    } else {
      t28 = $[38];
    }
    let t29;
    if ($[39] !== dealer.afterSaleOpenTimeRemark) {
      t29 = !!dealer.afterSaleOpenTimeRemark && <p className="text-caption text-gray-600">*{dealer.afterSaleOpenTimeRemark}</p>;
      $[39] = dealer.afterSaleOpenTimeRemark;
      $[40] = t29;
    } else {
      t29 = $[40];
    }
    if ($[41] !== t28 || $[42] !== t29) {
      t12 = <div className="space-y-2" {...t13}>{t14}{t28}{t29}</div>;
      $[41] = t28;
      $[42] = t29;
      $[43] = t12;
    } else {
      t12 = $[43];
    }
    t7 = "space-y-2";
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = createDataAttributes({
        test: "dealer-detail-contact"
      });
      t9 = <p className="font-noto-bold">ข้อมูลการติดต่อ</p>;
      $[44] = t8;
      $[45] = t9;
    } else {
      t8 = $[44];
      t9 = $[45];
    }
    t2 = "grid grid-cols-2 gap-x-4 gap-y-2 text-gray-700";
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = createDataAttributes({
        test: "dealer-detail-contact-list"
      });
      $[46] = t3;
    } else {
      t3 = $[46];
    }
    let t30;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t30 = createDataAttributes({
        test: "contact-phone-title"
      });
      $[47] = t30;
    } else {
      t30 = $[47];
    }
    let t31;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <dt className="flex gap-x-2" {...t30}><Icon icon={<IconCall />} className="size-5" /><span className="font-noto-bold">โทรศัพท์</span></dt>;
      t31 = createDataAttributes({
        test: "contact-phone-list"
      });
      $[48] = t31;
      $[49] = t4;
    } else {
      t31 = $[48];
      t4 = $[49];
    }
    if ($[50] !== appointmentContacts) {
      t5 = <dd {...t31}><AppointmentContacts contacts={appointmentContacts} /></dd>;
      $[50] = appointmentContacts;
      $[51] = t5;
    } else {
      t5 = $[51];
    }
    t6 = !!lineLink && <><dt className="flex gap-x-2" {...createDataAttributes({
        test: "contact-line-title"
      })}><Icon icon={<IconLine />} className="size-5" /><span className="font-noto-bold">LINE</span></dt><dd><Link href={lineLink} target="_blank" className="block truncate text-gray-700 underline" {...createDataAttributes({
          test: "contact-line"
        })} {...createDataGA({
          eventName: SPECIAL_OFFER_EVENT_NAME,
          group: SPECIAL_OFFER_DATA_TEST.DEALER_LINE,
          click: true,
          url: lineLink,
          text: lineId
        })}>{lineId}</Link></dd></>;
    $[2] = appointmentContacts;
    $[3] = dealer.afterSaleOpenTimeHourMonFri;
    $[4] = dealer.afterSaleOpenTimeHourSat;
    $[5] = dealer.afterSaleOpenTimeHourSun;
    $[6] = dealer.afterSaleOpenTimeRemark;
    $[7] = lineId;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[8];
    t11 = $[9];
    t12 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t13;
  if ($[52] !== t2 || $[53] !== t3 || $[54] !== t4 || $[55] !== t5 || $[56] !== t6) {
    t13 = <dl className={t2} {...t3}>{t4}{t5}{t6}</dl>;
    $[52] = t2;
    $[53] = t3;
    $[54] = t4;
    $[55] = t5;
    $[56] = t6;
    $[57] = t13;
  } else {
    t13 = $[57];
  }
  let t14;
  if ($[58] !== t13 || $[59] !== t7 || $[60] !== t8 || $[61] !== t9) {
    t14 = <div className={t7} {...t8}>{t9}{t13}</div>;
    $[58] = t13;
    $[59] = t7;
    $[60] = t8;
    $[61] = t9;
    $[62] = t14;
  } else {
    t14 = $[62];
  }
  let t15;
  if ($[63] !== t10 || $[64] !== t11 || $[65] !== t12 || $[66] !== t14) {
    t15 = <div className={t10} {...t11}>{t12}{t14}</div>;
    $[63] = t10;
    $[64] = t11;
    $[65] = t12;
    $[66] = t14;
    $[67] = t15;
  } else {
    t15 = $[67];
  }
  return t15;
};
function _temp(group, index) {
  return <li key={`${group.stripDash}-${index}`}><AppointmentContactLink group={group} index={index} /></li>;
}